import getWindowData from './getWindowData';
function getComponentData(element) {
  const dataBlobId = element.getAttribute('data-blob-id');
  const props = dataBlobId && getWindowData(dataBlobId);
  if (props) {
    return props;
  }
  const mountPointProps = element.getAttribute('data-props');
  if (mountPointProps) {
    return JSON.parse(mountPointProps);
  }
  return null;
}
export default getComponentData;